import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { resolveProductEntry } from '../services/productEntry';
import { useTenant } from '../contexts/TenantContext';
import { useLanguage } from '../i18n';
import ChooseWorkspace from '../pages/ChooseWorkspace';
import { workspaceCopy } from '../workspaceCopy';

export default function ProductWorkspaceGate({ children, product = 'front_desk' }) {
  const location = useLocation();
  const { isAuthenticated } = useTenant();
  const [entry, setEntry] = useState(null); const [failed, setFailed] = useState(false); const [attempt, setAttempt] = useState(0);
  const { lang } = useLanguage(); const copy = workspaceCopy(lang);
  useEffect(() => {
    if (!isAuthenticated) return undefined;
    let active = true; setFailed(false);
    resolveProductEntry().then((value) => { if (active) setEntry(value); }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [attempt, isAuthenticated]);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (entry?.legacy && new URLSearchParams(location.search).get('from') === 'legacy-staff') return <Box p={8}><Text>请联系管理员确认账号业务归属后重新登录。 / Please ask your administrator to restore this account's business access, then sign in again.</Text><Button as="a" href="/login">返回登录 / Sign in</Button></Box>;
  if (entry?.legacy && entry.product === 'ecommerce') return <LegacyEntry url={entry.entry_url} />;
  if (entry?.legacy && entry.product === 'choose') return <ChooseWorkspace />;
  if (entry?.product === product) return children;
  // Sign-in lands on the first page load: the generic /app entry, or a page
  // the partner chose (OneSuite sends paths such as /app/extensions). Being
  // moved to the right workspace then is expected, so the notice is only
  // shown when the user navigated to the other product's page in the app.
  const landing = location.key === 'default' || /^\/app\/?$/.test(location.pathname);
  const workspaceNotice = lang === 'zh' ? '已返回你所属业务的首页。' : 'You have been returned to your business homepage.';
  if (entry) return <Navigate to={entry.product === 'ecommerce' ? '/app/ecommerce' : '/app/settings'} replace state={landing ? undefined : { workspaceNotice }} />;
  return <Box as="main" maxW="40rem" mx="auto" px={6} py={12}>
    <Heading size="lg">{copy.title}</Heading>
    <Text role={failed ? 'alert' : 'status'} my={4}>{failed ? copy.loadError : copy.loading}</Text>
    {failed && <Button onClick={() => setAttempt((value) => value + 1)}>{copy.retry}</Button>}
  </Box>;
}

function LegacyEntry({ url }) {
  useEffect(() => { window.location.replace(url); }, [url]);
  return <Text>正在打开原有入口… / Opening your existing workspace…</Text>;
}
